"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Sparkles } from "lucide-react";
export default function ThePowerOfBranding() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224184" id="our-story" className="bg-background text-foreground py-24 md:py-32 px-4 md:px-8 overflow-hidden">
      <div ref={ref} className={`max-w-4xl mx-auto transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="border border-border p-8 md:p-16 lg:p-24 relative bg-card shadow-xl shadow-foreground/5 rounded-xl">
          <div className="flex justify-center mb-8">
            <Sparkles className="w-8 h-8 text-primary" strokeWidth={1} />
          </div>

          <h2 className="font-default text-3xl md:text-4xl lg:text-6xl text-foreground mb-12 text-center tracking-tight">
            The Editorial Vision
          </h2>

          <div className="space-y-8 text-lg md:text-xl font-default text-muted-foreground leading-relaxed max-w-3xl mx-auto">
            <p>
              <span className="text-5xl md:text-7xl font-bold text-primary float-left mr-4 mt-2 leading-none">A</span>
              t sexpleasure.store, we believe that wellness and intimacy deserve a{" "}
              <strong className="font-semibold text-foreground">
                sophisticated, editorial lens
              </strong>
              . Our mission is to bridge the gap between modern science and human connection, providing a space where curiosity meets clarity.
            </p>
            <p>
              We have curated a digital sanctuary that prioritizes{" "}
              <strong className="font-semibold text-foreground">
                empowerment and elegance
              </strong>{" "}
              over clinical jargon. Every guide, news piece, and wellness tip is crafted to help you navigate the complexities of modern love with confidence and grace, ensuring you have the tools to thrive.
            </p>
            <p>
              By blending high-authority journalism with a neo-minimalist aesthetic, we invite you to explore a world of{" "}
              <strong className="font-semibold text-foreground">
                intentional living
              </strong>
              . This isn't just a blog; it's a playbook for the modern individual who values depth, quality, and the pursuit of a more fulfilling, connected life.
            </p>
          </div>
        </div>
      </div>
    </section>;
}